import { CalculatorLink } from '@/components/blog/CalculatorLink'
import { BlogLink } from '@/components/blog/BlogLink'

export default function Article() {
  return (
    <>
      <p>
        Nadpłata kredytu hipotecznego to jedna z najskuteczniejszych metod obniżenia całkowitego
        kosztu kredytu. Nawet niewielka dodatkowa kwota płacona co miesiąc może zaoszczędzić
        dziesiątki, a nawet setki tysięcy złotych na odsetkach.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Jak działa nadpłata?</h2>
      <p>
        Kiedy nadpłacasz kredyt, dodatkowa kwota idzie bezpośrednio na zmniejszenie kapitału
        (kwoty głównej). Mniejszy kapitał oznacza mniejsze odsetki w kolejnych miesiącach.
        Efekt narasta z czasem jak kula śnieżna — im wcześniej zaczniesz nadpłacać, tym więcej zaoszczędzisz.
      </p>
      <p className="mt-3">
        Bank oferuje zwykle dwie opcje po nadpłacie: skrócenie <BlogLink slug="okres-kredytu-hipotecznego">okresu kredytowania</BlogLink> (rata
        zostaje taka sama, ale spłacasz szybciej) lub zmniejszenie raty (okres ten sam, ale płacisz mniej).
        Skrócenie okresu jest zazwyczaj korzystniejsze finansowo.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Ile można zaoszczędzić?</h2>
      <p>
        Przykład dla kredytu 400 000 zł na 25 lat przy <BlogLink slug="co-to-jest-wibor">oprocentowaniu 7,85%</BlogLink>:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Nadpłata 500 zł/mies.</strong> — oszczędzasz ok. 187 000 zł na odsetkach i spłacasz 9 lat wcześniej</li>
        <li><strong>Nadpłata 1 000 zł/mies.</strong> — oszczędzasz ok. 277 000 zł i spłacasz 13 lat wcześniej</li>
        <li><strong>Nadpłata 2 000 zł/mies.</strong> — oszczędzasz ok. 383 000 zł i spłacasz 18 lat wcześniej</li>
      </ul>

      <div className="mt-4">
        <CalculatorLink propertyPrice={500000} downPaymentPercent={20} loanYears={25} monthlyOverpayment={1000} section="overpayment">
          Sprawdź ile zaoszczędzisz w kalkulatorze
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Kiedy warto nadpłacać?</h2>
      <p>Nadpłata jest szczególnie opłacalna, gdy:</p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Jesteś na początku spłaty</strong> — wtedy odsetki stanowią największą część raty</li>
        <li><strong>Oprocentowanie jest wysokie</strong> — im wyższe odsetki, tym więcej oszczędzasz nadpłacając (gdy <BlogLink slug="obnizki-stop-procentowych-2026">stopy procentowe spadają</BlogLink>, efekt nadpłaty maleje)</li>
        <li><strong>Masz poduszkę finansową</strong> — zachowaj rezerwę na 3-6 miesięcy wydatków przed nadpłacaniem</li>
        <li><strong>Nie masz lepszych opcji inwestycyjnych</strong> — jeśli stopa zwrotu z inwestycji jest niższa niż oprocentowanie kredytu, nadpłata jest lepszym wyborem</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Na co uważać?</h2>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Prowizja za nadpłatę</strong> — niektóre banki pobierają opłatę za wcześniejszą spłatę w pierwszych 3 latach</li>
        <li><strong>Minimalna kwota nadpłaty</strong> — sprawdź w umowie, czy jest minimalna kwota jednorazowej nadpłaty</li>
        <li><strong>Forma nadpłaty</strong> — regularna nadpłata miesięczna vs jednorazowa nadpłata roczna (efekt zależy też od typu rat — <BlogLink slug="raty-rowne-czy-malejace">raty równe czy malejące</BlogLink>)</li>
        <li><strong>Poduszka finansowa</strong> — nie nadpłacaj kosztem bezpieczeństwa finansowego rodziny</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Podsumowanie</h2>
      <p>
        Nadpłata kredytu hipotecznego to prostą i skuteczna strategia oszczędzania. Nawet 500 zł
        miesięcznie może przynieść ponad 187 000 zł oszczędności i skrócić kredyt o 9 lat.
        Skorzystaj z kalkulatora RatyGo, aby dokładnie obliczyć ile zaoszczędzisz przy swojej kwocie nadpłaty.
      </p>

      <div className="mt-4">
        <CalculatorLink monthlyOverpayment={500} section="overpayment">
          Oblicz swoją oszczędność na nadpłacie
        </CalculatorLink>
      </div>
    </>
  )
}
